import { mobileBreakpoint } from '../../theme'

/** Both thresholds must mirror GridContainer's media queries in AlbumsScreen. */
const TWO_COLUMN_MAX_WIDTH = 1000

export const columnCountFor = (width: number): number => {
  if (width <= mobileBreakpoint.width) return 1
  if (width <= TWO_COLUMN_MAX_WIDTH) return 2
  return 3
}

/**
 * Placeholders to append while the next page loads: enough to finish the row the last
 * album started, plus one full row. The albums endpoint returns no total, so the real
 * remainder is unknowable — a whole page of 20 would just add dead scroll height.
 */
export const skeletonCountFor = (loadedCount: number, columnCount: number): number => {
  if (columnCount <= 0) return 0
  const remainder = loadedCount % columnCount
  const rowFiller = remainder === 0 ? 0 : columnCount - remainder
  return rowFiller + columnCount
}
